module.exports = __webpack_public_path__ + "static/media/ren.32f0c5cf.svg";